import { Directive, ElementRef, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import ResizeObserver from 'resize-observer-polyfill';

const entriesMap = new WeakMap();

const resizeObserver = new ResizeObserver((entries) => {
  for (const entry of entries) {
    if (entriesMap.has(entry.target)) {
      const comp = entriesMap.get(entry.target);
      comp._resizeCallback(entry);
    }
  }
});

@Directive({ selector: '[resize-observer]' })
export class ResizeObserverDirective implements OnDestroy {
  @Output()
  resize = new EventEmitter();

  constructor(private el: ElementRef) {
    const target = this.el.nativeElement;
    entriesMap.set(target, this);
    resizeObserver.observe(target);
  }

  ngOnDestroy() {
    const target = this.el.nativeElement;
    resizeObserver.unobserve(target);
    entriesMap.delete(target);
  }

  private _resizeCallback(entry) {
    this.resize.emit(entry);
  }
}
